var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{staticClass:"btn-blue",on:{"click":_vm.send}},[_vm._v("发送")])
}
var staticRenderFns = []

export { render, staticRenderFns }